import React from "react"

import MenuProvider from "./src/context/menu-provider"

export const wrapRootElement = ({ element }) => (
  <MenuProvider>{element}</MenuProvider>
)


